import commonObj from "../../../../services/common.js";
import { HTTP } from "../../../../services/api-service.js";
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = "MMBundleItem";
var tableName2 = "MMBundleLine";
var tableName3 = "MMBundlePx";
const bundleItemStore = {
  namespaced: true,
  state: {
    totalItem: 0,
    q: {
      tableNeedQuery:"vwMMBundleItem",//更新获取所有子商品的API
      isOuterJoin: false,
      searchCriteria: "",
      orderBy: "BdlID,asc",
      //orderBy: "",
      take: 1000000,
      skip: 0
    },
    currentSelectedPage: 0
  },
  actions: {
    //获取所有子商品
    getAllBundleItem({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        state.q.searchCriteria="";
        HTTP.post(baseUrl + "/qgl/listvalue", state.q).then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    //获取币种列表(CB_Cur)
    getCurrencyList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/qgl/listvalue", {
          tableNeedQuery: "Currency",
          isOuterJoin: false,
          searchCriteria: "",
          orderBy: "CurrencyCode,asc",
          take: 1000000,
          skip: 0
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    //保存第三层币种分摊价
    saveBundleItemPx({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/mm/save",
          JSON.stringify({
            type: tableName3,
            modelList: param.bundleItemPxModel,
            option: param.option
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    //查询所有捆绑列表
    getBundleList({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/BundleList",{ActiveOnly:false}).then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    //查询每个列表下的绑定的商品信息
    getBundle({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/Bundle",param).then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
     //新增捆绑信息
     AddNewBundle({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/AddNewBundle",param).then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
     //修改捆绑信息
     UpdBundle({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/UpdBundle",param).then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    //删除捆绑信息
    DelBundle({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(baseUrl + "/invoice/DelBundle",param).then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    //保存
    saveBundleItem({ commit }, param) {
      return new Promise((resolve, reject) => {
        HTTP.post(
          baseUrl + "/mm/save",
          JSON.stringify({
            type: tableName,
            modelList: param.bundleItemModel,
            option: param.option
          })
        )
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
       //保存第二层的数据
       saveBundleLine({ commit }, param) {
        return new Promise((resolve, reject) => {
          HTTP.post(
            baseUrl + "/mm/save",
            JSON.stringify({
              type: tableName2,
              modelList: param.bundleLineModel,
              option: param.option
            })
          )
            .then(response => {
              resolve(response);
            })
            .catch(e => {
              reject(e);
            });
        });
      },
  }
};
export default bundleItemStore;
